module.exports = __webpack_public_path__ + "img/geolocalisation-famille-boutrais.13e2b326.webp";